import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './index.css'
import {Select, Input} from '@chakra-ui/react'


const StoreLocationCard = ({ store }) => {

  useEffect(() => {
    document.title = 'Mukunda jewellers | Stores';
  }, []);

  return (
    <a className="store-card" href = {store.mapUrl} target="_blank">
        <div className='imge-div'><img src={store.image} alt={store.name} className='store-image' /></div>
        <h2>{store.name}</h2>
        <p>{store.address}</p>
        <p>Phone no: {store.phoneNumber}</p>
        <p>City: {store.name}</p>
    </a>
  );
};

const StoreLocationPage = () => {
  const [stores, setStores] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPinCode, setSelectedPinCode] = useState('');
  const [pinCodes, setPinCodes] = useState([]);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_HOST}/api/stores`);
        setStores(response.data.data);
        // Extract unique pin codes from the stores data
        const uniquePinCodes = Array.from(new Set(response.data.data.map(store => store.name)));
        setPinCodes(uniquePinCodes);
      } catch (error) {
        console.error('Error fetching stores:', error);
      }
    };

    fetchStores();
  }, []);

  const filteredStores = stores.filter(store =>
    store.pinCode.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handlePinCodeChange = (e) => {
    setSelectedPinCode(e.target.value);
    setSearchTerm('');
  };

  const filteredStoresByPinCode = selectedPinCode ? stores.filter(store =>
    store.name === selectedPinCode
  ) : [];

  return (
    <div className="store-page">
      <div className='searchbar-div'>
        <Select value={selectedPinCode} onChange={handlePinCodeChange} width = '200px'>
          <option value="">All Cities</option>
          {pinCodes.map(pinCode => (
            <option key={pinCode} value={pinCode}>{pinCode}</option>
          ))}
        </Select>
      </div>
      <div className="store-grid">
        {selectedPinCode ? filteredStoresByPinCode.map(store => (
          <StoreLocationCard key={store._id} store={store} />
        )) : filteredStores.map(store => (
          <StoreLocationCard key={store._id} store={store} />
        ))}
      </div>
    </div>
  );
};

export default StoreLocationPage;
